import { DropDownModel } from "@/models";
import {
  correctionReasonCodeList,
  elaStatusCodeList,
  spedPlanTypeCodeList,
  spedStatusList,
} from "@/queries/calpadsSyncMockLookups";

type CoreData = {
  languagesList: DropDownModel[];
};

export function useCalpadsSyncFieldTransformers(coreData: CoreData) {
  const findText = (list: DropDownModel[], code: string | null | undefined) => {
    if (!code) return "—";
    return list.find((x) => x.Value === code)?.Text ?? code;
  };

  return {
    getElaStatusText: (code: string | null | undefined) =>
      findText(elaStatusCodeList, code),
    getCorrectionReasonText: (code: string | null | undefined) =>
      findText(correctionReasonCodeList, code),
    getPrimaryLanguageText: (code: string | null | undefined) =>
      findText(coreData.languagesList, code),
    getSpedStatusText: (code: string | null | undefined) =>
      findText(spedStatusList, code),
    getSpedPlanTypeText: (code: string | null | undefined) => {
      if (!code) return "—";
      return (
        spedPlanTypeCodeList.find((x) => x.Value === code)?.Text ?? "Other"
      );
    },
  };
}
